/**
 * Created by Mikhail Menshenin on 06.08.2024
 */

const VillageHammerView = cc.Node.extend({
    avoidNode: "hammer",

    ctor: function (village) {
        this._super();

        this.village = village;

        const styles = cleverapps.styles.VillageHammerView;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles.size);

        this.icon = new cc.Sprite(bundles.buttons.frames.button_grey_bg);
        this.icon.setContentSize2(styles.size);
        this.icon.setAlignment(styles.hammer);
        this.addChild(this.icon);

        const hammer = new cc.Sprite(bundles.buttons.frames.button_hammer);
        hammer.setAlignment(styles.hammer);
        this.addChild(hammer);

        const attention = new DualAttention({
            model: village,
            key: "attention",
            event: "changeAttention",
            scale: styles.attention.scale
        });
        attention.setAlignment(styles.attention);
        this.addChild(attention);

        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.setScale(styles.mobileScale);
        }

        cleverapps.UI.applyHover(this);
        cleverapps.UI.onClick(this, this.onClick.bind(this));

        village.on("changeAttention", this.updateButton.bind(this), this);
        this.updateButton();
    },

    onClick: function () {
        if (cleverapps.forces.getRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        this.village.openUpgradeWindow();
    },

    updateButton: function () {
        this.icon.setSpriteFrame(this.village.attention ? bundles.buttons.frames.button_green_bg : bundles.buttons.frames.button_grey_bg);
    }
});

cleverapps.styles.VillageHammerView = {
    size: {
        width: 150,
        height: 150
    },
    mobileScale: 0.75,
    attention: {
        x: { align: "right", dx: 36 },
        y: { align: "top", dy: 36 },
        scale: 1.4
    },
    hammer: {
        x: { align: "center", dx: 3 },
        y: { align: "center", dy: 0 }
    }
};
